export enum AppRouterName {
  ProductDetail = "/productDetail",
  SampleDetail = "/sampleDetail",
  VipCenter = "/vipCenter",
  HigherComm = "/higherComm",
  AdTaskDetailPage = "/adTaskDetailPage",
  Wallet = "/wallet",
  MashupSelectScript = "/mashupSelectScript",
}
